import React from 'react';
import AnimatedText from '../Components/animation/text/AnimatedText';


const Contact = () => {
    return (
        <div id="contact" className="w-full flex flex-col items-center justify-center overflow-hidden mt-10">
            <div className="w-full xl:w-[70%] flex flex-row pb-16">
                <div className="w-full">
                    <AnimatedText text="Contact" />

                    <p className="text-secondary-400 text-[18px] mt-5 ml-12">
                        I'm always open to new opportunities and challenges. Feel free to contact me through the following channels:

                    </p>

                    <p className="text-secondary-400 text-[18px] mt-4 ml-[5em]">
                        &gt; <span className="font-bold bg-clip-text bg-gradient-to-tr from-pink-600 to-purple-700"> Email: </span>
                        <span className='inline-block bg-red-500 text-primary-400 px-2 py-1 rounded-full border-2 ml-2 hover:bg-secondary-100 select-none'>
                            <a href="mailto:ricardo.andre.de.matos@gmail.com">
                                ricardo.andre.de.matos@gmail.com
                            </a>
                        </span>
                    </p>

                    <p className="text-secondary-400 text-[18px] mt-4 ml-[5em]">
                        &gt; <span className="font-bold bg-clip-text bg-gradient-to-tr from-pink-600 to-purple-700"> Linkedin: </span>
                        <span className='inline-block bg-red-500 text-primary-400 px-2 py-1 rounded-full border-2 ml-2 hover:bg-secondary-100 select-none'>
                            <a href="https://www.linkedin.com/in/ricardo-matos-41939b242/">
                                Ricardo Matos
                            </a>
                        </span>
                    </p>

                    <p className="text-secondary-400 text-[18px] mt-4 ml-[5em]">
                        &gt; <span className="font-bold bg-clip-text bg-gradient-to-tr from-pink-600 to-purple-700"> Github: </span>
                        <span className='inline-block bg-red-500 text-primary-400 px-2 py-1 rounded-full border-2 ml-2 hover:bg-secondary-100 select-none'>
                            <a href="https://github.com/Rica320">
                                Rica320
                            </a>
                        </span>
                    </p>

                    <p className="text-secondary-400 text-[18px] mt-5 ml-12">
                        Hope to hear from you soon! 😁 You can also check my
                        <span className='inline-block bg-red-500 text-primary-400 px-2 py-1 rounded-full border-2 ml-2 hover:bg-secondary-100 select-none'>
                            <a href="https://drive.google.com/file/d/1ChODvL_9-biJ3HI0aJOkH7MPiJ5F9pIv/view?usp=sharing">
                                Resume
                            </a>
                        </span>

                    </p>
                </div>

            </div>

        </div>
    );
}

export default Contact;

